<template>
	<div class="ReSelectCascade">		
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Название ЖК</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Название ЖК"				
				filterable
				v-model="value.gk_name_tr"
				@change="onComplex"		
				clearable

			>
				<el-option
					v-for="(el_opt, el_index) in masComplex"
					class="select-primary"
					:value="el_opt.gk_name_tr"
					:label="el_opt.gk_name_dev_name"
					:key="el_index"                    
				>
				</el-option>
			</el-select>
		</div>
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Корпус</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Корпус"
				v-model="value.gk_block"
				@change="onCorp"
			>
				<el-option
					v-for="(corp, el_index) in masCorpOpts"
					class="select-primary"
					:value="corp"
					:label="corp"
					:key="el_index"
				>
				</el-option>
			</el-select>
		</div>
		<div class="row">
			<label class="col-form-label col-md-12 formRequired"><span>Секция</span></label>
			<el-select
				class="col-md-12 select-primary"
				size="large"                
				placeholder="Секция"
				v-model="value.gk_sections"
			>
				<el-option
					v-for="(sec, el_index) in masSectionOpts"
					class="select-primary"
					:value="sec"
					:label="sec"
					:key="el_index"                    
				>
				</el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReSelectCascade',
		components: {
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: Object,
			findId: {
				type: String,
				default: '',
			},
			required:{
				type: Boolean,
				default: false
			},
			
		},
		data () {
			return {
				ver: 1,	
				masComplex: [],  
				masCorpOpts: [],
				objCurComplexBloks: {},
				masSectionOpts:[],
			}
		},
		computed: {

		},
		methods: {
			onComplex(gk_name_tr,bForce=false){
				if(!bForce){
					this.value.gk_block = '';
				}
				this.objCurComplexBloks = [];
				for (let i = 0; i < this.masComplex.length; i++) {
					if(this.masComplex[i].gk_name_tr == gk_name_tr){
						if(typeof this.masComplex[i].block_tree != 'undefined' && this.masComplex[i].block_tree != ''){ // тут стояло block_tree2 -- или опечатка, или было такое поле?
							//console.log(this.masComplex[i].block_tree);
							this.objCurComplexBloks = this.$GVO.SafeParseJson(this.masComplex[i].block_tree); 
							this.masCorpOpts = Object.keys(this.objCurComplexBloks);
							return true;
						}
					}
				}
			},
			onCorp(gk_block){
				this.value.gk_sections = '';
				this.masSectionOpts = this.objCurComplexBloks[gk_block];
			},
			GetComplexList(){
				this.$GVO.ApiCall('GET_COMPLEX_LIST',{obj:'NovoObj', flt:{list:true}})
				.then((objApi) => {		
					//console.log(objApi);		
					if(objApi.success === true){
						if(objApi.data.length > 0){
							for (let i = 0; i < objApi.data.length; i++) {
								objApi.data[i]['gk_name_dev_name'] = `${objApi.data[i].gk_name} ( ${objApi.data[i].dev_name} )`; //это нужно для ускорения отрисовки
							}
							this.masComplex = objApi.data;
							if (this.value.gk_name_tr != '') {
								this.onComplex(this.value.gk_name_tr,true);
							}
						}					
					}
				}).catch(errorObjApi => {console.error(errorObjApi);});
			},
			// cancalReadOnly(onOff) {
            //     this.$nextTick(() => {
            //         if (!onOff) {
            //             const {select} = this.$refs;
            //             const input = select.$el.querySelector('.el-input__inner');
            //             input.removeAttribute('readonly');
            //         }
            //     });
            // }
		},
		mounted() {
			this.GetComplexList();           
		}
	}
</script>
<style scoped>
.white-content .el-input input::placeholder {color:#222a42;} 
.white-content .form-options-group  >>> .el-input__inner::placeholder {color:#222a42;} 
</style>
